import * as Yup from 'yup'

export const validationSchemasAprobacionObjecion = (clasRespuesta, validaAbogados) => {
    let validation = {};

    validation.clasificaRespuesta = Yup.string().required('Este campo es obligatorio.');
    validation.motivoRespuestaCIA = Yup.string().required('Este campo es obligatorio.');
    validation.fechaRespuesta = Yup.string().required('Este campo es obligatorio.');
    if (validaAbogados) {
        validation.abogado = Yup.string().required('Este campo es obligatorio.');
    }
    
    validation.porcConvenio = Yup
        .string().typeError('Debe ingresar un número.')
        .required('Este campo es obligatorio.')
        .test('mayorCien', 'El valor no puede ser mayor a 100.', value => Number(value) <= 100)
        .test('igualCero', 'El valor no puede ser igual a 0.', value => Number(value) > 0);

    if (clasRespuesta != 227024) {//Pendiente Condicionado
        validation.porcConvenio = Yup
        .string().typeError('Debe ingresar un número.')
        .required('Este campo es obligatorio.')
        .test('mayorCien', 'El valor no puede ser mayor a 100.', value => Number(value) <= 100)
        .test('igualCero', 'El valor no puede ser igual a 0.', value => Number(value) > 0);
    } else {
        validation.porcConvenio = Yup
        .string().typeError('Debe ingresar un número.')
        .required('Este campo es obligatorio.')
        .test('mayorCien', 'El valor no puede ser mayor a 100.', value => Number(value) <= 100)
    }

    return Yup.object().shape(validation);
}
export const validationSchemasDestinatario = () => {
    let validation = {};

    validation.idTipoDestinatario = Yup.string().required('Este campo es obligatorio.');
    validation.idClasificaDestino = Yup.string().required('Este campo es obligatorio.');
    validation.nombreDestinatario = Yup.string().required('Este campo es obligatorio.');
    validation.emailDestinatario = Yup.string().required('Este campo es obligatorio.').email('Email inválido.');

    return Yup.object().shape(validation);
}